var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box as MuiBox } from '@mui/material';
import colors from '../../colors';
import Typography from '../Typography';
import { Check as CheckIcon } from '../../icons';
export var BadgeTestId = 'Sweep_Badge';
export var BadgeTestIconId = 'Sweep_Badge_Icon';
var badgeColors = {
    primary: {
        backgroundColor: colors.blue[100],
        color: colors.blue[500],
    },
    secondary: {
        backgroundColor: colors.grey[120],
        color: colors.grey[800],
    },
    destructive: {
        backgroundColor: colors.blush[500],
        color: colors.white,
    },
};
var Badge = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, label = _a.label, _c = _a.showDone, showDone = _c === void 0 ? false : _c, _d = _a.showZero, showZero = _d === void 0 ? false : _d;
    var showNumericContent = !showDone && label !== undefined;
    if (!showZero && label === 0) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs(MuiBox, __assign({ "data-testid": BadgeTestId, sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: badgeColors[variant].backgroundColor,
            color: badgeColors[variant].color,
            padding: '3px 4px',
            borderRadius: '50px',
            border: "2px solid ".concat(colors.white),
            minWidth: '24px',
            maxWidth: showDone ? '24px' : 'fit-content',
            height: '24px',
        } }, { children: [showNumericContent && (_jsx(Typography, __assign({ variant: variant === 'secondary' ? 'caption' : 'caption-bold' }, { children: label }))), showDone && _jsx(CheckIcon, { "data-testid": BadgeTestIconId, color: badgeColors[variant].color })] })));
};
export default Badge;
